// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_bx","postedByDate":"e_cx","container":"e_dx","description":"e_ex","title":"e_fx"};